import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/home/Home.vue'),
  },
  {
    path: '/create',
    name: 'Create',
    component: () => import('../views/create/Create.vue'),
    props: true,
  },
  {
    path: '/detail/:id',
    name: 'Detail',
    component: () => import('../views/detail/Detail.vue'),
    props: true
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.name !== 'Home' || from.name !== 'Home') {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
